import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'

export default class extends Controller {

  connect() {
    this.paginationElement = this.element.querySelector('.pagination');

    if(this.paginationElement) {
      this.paginationElement.addEventListener('click', (ev)=> {
        ev.preventDefault()
        this.handlePaginationClick(ev)
      })
    }
  }

  async reload() {
    let url
    let pageLink
    if(this.paginationElement) {
      pageLink = this.paginationElement.querySelector('li.current span[data-href]')
      if(!pageLink?.dataset?.href) pageLink = null
    }

    if(!url && pageLink) url = new URL(pageLink.dataset.href, window.location.origin)
    if(!url) url = new URL(window.location.toString())

    let search = new URLSearchParams(url.search)

    if(pageLink) {
      let u = new URL(pageLink.dataset.href, window.location.origin)
      let s = new URLSearchParams(u.search)
      for(const k of s.keys()) {
        search.set(k, s.get(k))
      }
    }
    url.search = search

    let response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    let html = await response.text()
    this.update(html)
  }

  async handlePaginationClick(ev) {
    if(ev.target.tagName == 'A') {
      let url = new URL(ev.target.href, window.location.origin)
      let search = new URLSearchParams(url.search)
      url.search = search
      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      let html = await response.text()
      this.update(html)
    }
  }

  update(html) {
    let parser = new DOMParser()
    let parsed = parser.parseFromString(html, 'text/html')
    let newHtml = parsed.querySelector(`#${this.element.id}`)?.parentNode?.innerHTML

    this.element.parentNode.innerHTML = newHtml||html
    $(document).foundation();
  }
}
